const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;

export default {
  baseUrl,
  jsonGs: process.env.REACT_APP_GS || 'AVerySecretSecret',
  routes: {
    discordAuth: `${baseUrl}/auth/discord/login`,
    currentUser: `${baseUrl}/user/current`,
    played: (game: string) => `${baseUrl}/games/${game}/played`,
    recentHighScores: (game: string) =>
      `${baseUrl}/games/${game}/recent-highscores`,
  },
};
